export default function Wordmark({ size = "md" }) {
  const sizes = {
    sm: { j: "text-2xl", v: "text-lg", gap: "gap-1" },
    md: { j: "text-3xl", v: "text-xl", gap: "gap-1.5" },
    lg: { j: "text-6xl sm:text-7xl", v: "text-3xl sm:text-4xl", gap: "gap-3" },
    xl: { j: "text-7xl sm:text-8xl", v: "text-4xl sm:text-5xl", gap: "gap-3" },
  }[size] || {};
  return (
    <span className={`inline-flex items-baseline ${sizes.gap}`}>
      <span
        className={`h-font font-extrabold italic ${sizes.j}`}
        style={{
          color: "#00E7FF",
          textShadow: "0 0 24px rgba(0,231,255,0.55), 0 0 4px rgba(0,231,255,0.9)",
          WebkitTextStroke: "1px rgba(255,255,255,0.15)",
        }}
      >
        Jixxeo
      </span>
      <span
        className={`h-font font-extrabold italic ${sizes.v}`}
        style={{
          color: "#FF3EA5",
          textShadow: "0 0 20px rgba(255,62,165,0.6), 0 0 4px rgba(255,62,165,0.9)",
        }}
      >
        videos
      </span>
    </span>
  );
}
